const teamsByNation = [
  {
    nation: 'England',
    leagues: [
      {
        league: 'Premier Division',
        teams: [
          'Arsenal',
          'Chelsea',
          'Tottenham Hotspur',
          'Liverpool',
          'Manchester United',
          'Manchester City',
          'Nottingham Forest',
          'Everton',
          'West Ham United',
          'Crystal Palace',
          'Wolverhampton Wanderers',
          'Newcastle United',
          'Aston Villa',
          'Brentford',
          'Bournemouth',
          'Brighton & Hove Albion',
          'Fulham',
          'Burnley',
          'Sunderland',
          'Leeds United'
        ]
      },
      {
        league: 'Championship',
        teams: [
          'Leicester City',
          'Ipswich Town',
          'Southampton'
        ]
      }
    ]
  },
  {
    nation: 'Spain',
    leagues: [
      {
        league: 'Spanish First Division',
        teams: [
          'Real Madrid',
          'Barcelona',
          'Atlético Madrid',
          'Sevilla',
          'Valencia',
          'Real Sociedad',
          'Athletic Bilbao',
          'Osasuna',
          'Deportivo Alavés',
          'Elche',
          'Getafe',
          'Girona',
          'Levante',
          'Rayo Vallecano',
          'Real Betis',
          'Celta Vigo',
          'Mallorca',
          'Real Oviedo',
          'Espanyol',
          'Villarreal'
        ]
      }
    ]
  },
  {
    nation: 'Germany',
    leagues: [
      {
        league: 'German First Division',
        teams: [
          'Bayern Munich',
          'Borussia Dortmund',
          'RB Leipzig',
          'Union Berlin',
          'VfB Stuttgart',
          'Eintracht Frankfurt',
          'VfL Wolfsburg',
          'Bayer Leverkusen',
          'Mainz 05',
          'FC Köln',
          'Heidenheim',
          'Borussia Mönchengladbach',
          'FC Augsburg',
          'St. Pauli',
          'Hamburger SV',
          'SC Freiburg',
          'Werder Bremen',
          'TSG Hoffenheim'
        ]
      }
    ]
  },
  {
    nation: 'Italy',
    leagues: [
      {
        league: 'Italian First Division',
        teams: [
          'AC Milan',
          'Inter Milan',
          'Juventus',
          'Atalanta',
          'AS Roma',
          'Napoli',
          'Fiorentina',
          'Bologna',
          'Cagliari',
          'Como',
          'Genoa',
          'Parma',
          'Pisa',
          'Lazio',
          'Torino',
          'Udinese',
          'Cremonese',
          'Lecce',
          'Sassuolo',
          'Hellas Verona'
        ]
      }
    ]
  },
  {
    nation: 'France',
    leagues: [
      {
        league: 'French First Division',
        teams: [
          'Paris Saint-Germain',
          'Lyon',
          'Olympique de Marseille',
          'AS Monaco',
          'Lille',
          'Angers',
          'Auxerre',
          'Lorient',
          'Metz',
          'Nantes',
          'Le Havre',
          'Nice',
          'Paris FC',
          'Lens',
          'Strasbourg',
          'Rennes',
          'Brest',
          'Toulouse'
        ]
      }
    ]
  },
  {
    nation: 'Portugal',
    leagues: [
      {
        league: 'Portuguese First Division',
        teams: [
          'FC Porto',
          'Benfica',
          'Sporting CP'
        ]
      }
    ]
  },
  {
    nation: 'Netherlands',
    leagues: [
      {
        league: 'Dutch First Division',
        teams: [
          'Ajax',
          'PSV',
          'Feyenoord',
        ]
      }
    ]
  },
  {
    nation: 'Saudi Arabia',
    leagues: [
      {
        league: 'Saudi Pro League',
        teams: [
          'Al-Ittihad',
          'Al-Ahli',
          'Al-Nassr',
          'Al-Hilal'
        ]
      }
    ]
  }
];

export default teamsByNation;
